import React from 'react';

import { Route } from '@wix/tpa-router/react';

import { CreateEventPage } from './CreateEventPage';
import { EventListPage } from './EventListPage';
import { EditEventPage } from './EditEventPage';

export function EventsPage() {
  return (
    <div data-hook="events-page">
      <Route state="group.events.create" component={CreateEventPage} />
      <Route state="group.events.list" component={EventListPage} />
      <Route state="group.events.edit" component={EditEventPage} />
    </div>
  );
}

EventsPage.displayName = 'EventsPage';
